<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">申请类型</span>
          <span class="btnGroup">
            <!-- <van-button
              @click="changeRadio2(0)"
              :class="{ active: radio2 == 0 }"
              plain
              size="medium"
              >全部</van-button
            > -->
            <van-button
              @click="changeRadio2(1)"
              :class="{ active: radio2 == 1 }"
              plain
              size="medium"
              >加入</van-button
            >
            <van-button
              @click="changeRadio2(2)"
              :class="{ active: radio2 == 2 }"
              plain
              size="medium"
              >退出</van-button
            >
          </span>
        </div>
        <my-table
          :tableData="joinList"
          :tableField="tableField"
          v-if="membersList.length && radio2 == '1'"
        >
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'op_time'">{{
              scope.row.value | formatTime
            }}</span>
            <span v-else-if="scope.row.key == 'audit_time'">{{
              scope.row.value | formatTimeAudit
            }}</span>
            <span v-else-if="scope.row.key == 'remain_day'">{{
              scope.row.value | remainDay
            }}</span>
            <span v-else-if="scope.row.key == 'op'">{{
              scope.row.value | requestType
            }}</span>
          </template>
          <template slot-scope="scope" slot="opt-slot">
            <span v-if="scope.row.state == 4">已撤销</span>
            <span v-else-if="scope.row.state == 3">已拒绝</span>
            <span v-else-if="scope.row.state == 2">已通过</span>
            <span v-else>
              <a type="text" @click="acceptClicked(scope.row)">通过</a> |
              <a type="text" @click="rejectClicked(scope.row)">拒绝</a>
            </span>
          </template>
        </my-table>
        <my-table
          :tableData="quitList"
          :tableField="exitField"
          v-else-if="membersList.length && radio2 == '2'"
        >
        </my-table>
        <NoData v-else></NoData>
        <div class="data-filter-page">
          <Pagination
            :tableInfo="pagination"
            @changCurrentPage="pageChange"
          ></Pagination>
        </div>
        <van-loading
          class="img-loading"
          type="spinner"
          color="#fd9b21"
          size="24px"
          v-show="tableLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getStudioRequest, studioRequestAudit } from '@/api/studio';
import { ONE_DAY, ONE_HOUR } from '../../CONST';
import Pagination from '../../../income/components/pagination';
import MyTable from '../../../../components/MyTable.vue';
import NoData from '@/components/NoData.vue';

const _formatTime = (time, audit) => {
  if (audit && time === 0) return '未审核';
  let t = new Date(time * 1000);
  return (
    t.getFullYear() +
    '-' +
    (101 + t.getMonth() + '').slice(-2) +
    '-' +
    (100 + t.getDate() + '').slice(-2)
  );
};
export default {
  data() {
    return {
      tableLoading: false,
      radio2: '1',
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      membersList: [],
      membersData: [],
      tableField: [
        { label: '昵称', prop: 'name' },
        { label: '', prop: '' },
        { label: '迷你号', prop: 'uin' },
        { label: '开发者等级', prop: 'creator_level' },
        { label: '申请时间', prop: 'op_time' },
        { label: '审核时间', prop: 'audit_time' },
        { label: '剩余处理时间', prop: 'remain_day' },
        { label: '公开作品', prop: 'map_count' },
        { label: '申请类型', prop: 'op' },
        { label: '操作', prop: 'operation' },
      ],
      exitField: [
        {
          label: '昵称',
          prop: 'name',
        },
        { label: '', prop: '' },
        {
          label: '迷你号',
          prop: 'uin',
        },
        {
          label: '退出时间',
          prop: 'timeStr',
        },
      ],
    };
  },
  components: {
    Pagination,
    MyTable,
    NoData,
  },
  created() {
    this.pagination.total = this.$route.params.join_quit_count || 0;
    this.getList();
    //加入退出申请页曝光埋点
    this.$log('join_quit_apply_show', 85446, { v7: 2 });
  },
  watch: {
    radio2: function (newVal) {
      switch (newVal) {
        // case '0':
        //   this.membersData = this.allList;
        //   break;
        case '1':
          this.membersData = this.joinList;
          break;
        case '2':
          this.membersData = this.quitList;
          break;
      }
      this.pagination.total = this.membersData.length;
      this.pageChange(1);
    },
  },
  computed: {
    allList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]');
    },
    joinList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]').filter(
        val => val.op != 7,
      );
    },
    quitList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]').filter(
        val => val.op == 7,
      );
    },
  },
  filters: {
    remainDay(op_time) {
      let day = Math.floor(7 - (Date.now() - op_time * 1000) / ONE_DAY);
      let hour = Math.floor(
        ((7 * ONE_DAY - Date.now() + op_time * 1000) % ONE_DAY) / ONE_HOUR,
      );
      return (day > 0 ? day : 0) + ' 天 ' + hour + ' 时';
    },
    requestType(op) {
      return op == 5 || op == 4 ? '加入' : '退出';
    },
    formatTime(time, audit) {
      return _formatTime(time, audit);
    },
    formatTimeAudit(time) {
      if (time === 0) return '未审核';
      let t = new Date(time * 1000);
      return (
        t.getFullYear() +
        '-' +
        (101 + t.getMonth() + '').slice(-2) +
        '-' +
        (100 + t.getDate() + '').slice(-2)
      );
    },
  },
  methods: {
    changeRadio2(num) {
      this.radio2 = num + '';
    },
    formatTime(time, audit) {
      return _formatTime(time, audit);
    },
    getList() {
      this.tableLoading = true;
      getStudioRequest({ json: 1 }).then(res => {
        this.tableLoading = false;
        res.data.forEach(val => {
          val.remain_day = val.op_time;
          val.timeStr = this.formatTime(val.op_time);
          // val.audit_time = this.formatTime(val.audit_time, 1);
        });
        this.membersData = res.data;
        this.pagination.total = res.data.length;
        this.initPageChange(1); //初始化列表
        sessionStorage.setItem('allList', JSON.stringify(res.data));
      });
    },
    pageChange(currPage) {
      this.pagination.page = currPage;
      let { page, pageSize } = this.pagination;
      this.membersList = this.membersData.slice(
        (page - 1) * pageSize,
        page * pageSize,
      );
    },
    initPageChange(currPage) {
      this.pagination.page = currPage;
      let { page, pageSize } = this.pagination;
      this.membersData = this.membersData.filter(val => val.op != 7);
      this.membersList = this.membersData.slice(
        (page - 1) * pageSize,
        page * pageSize,
      );
    },
    acceptClicked(info) {
      console.log('acceptClicked', info);
      let { op, uin } = info;
      studioRequestAudit({ op, member_uin: uin, json: 1, accept: 1 })
        .then(() => {
          this.$toast.success('操作成功');
          this.getList();
        })
        .catch(e => {
          console.log('studioRequestAudit accept err ---', e);
          this.getList();
        });
    },
    rejectClicked(info) {
      console.log('rejectClicked', info);
      let { op, uin } = info;
      studioRequestAudit({ op, member_uin: uin, json: 1, accept: 0 })
        .then(() => {
          this.$toast.success('操作成功');
          this.getList();
        })
        .catch(e => {
          console.log('studioRequestAudit reject err ---', e);
          this.getList();
        });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.btnGroup {
  ::v-deep button {
    width: 129px;
    height: 56px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    color: #262626;
    background: #fff;
    margin-right: 16px;
    &.active {
      border-color: #ffc973;
      background: #fffaed;
      color: #fd9b21;
    }
  }
}
</style>
